// Components
import { CustomButtonV2, CustomFormLabel, CustomTextField, ModalFooter, ModalHeader, ModalSubHeader } from "../../../../pages/styles";
import {
  Grid,
} from "@mui/material";

// Styles
import {
  Container,
  Body,
  ContainerInfo,
  SectionRight,
  Spacer,
  SectionTopInfo,
  SectionBottomInfo,
  Text,
  CustomFormControl,
  CustomCheckbox,
} from "./styles";

// Utils
import { useTranslation } from 'react-i18next'

export const RoleModalCard = ({
  title,
  data,
  errors,
  loading,
  handleClose,
  handleChange,
  handleAccept,
}) => {
	const { t } = useTranslation();
  
  return (
    <Container>
      <ModalHeader>{title}</ModalHeader>
      <ModalSubHeader/>
      <Body>
        <ContainerInfo>
          <SectionTopInfo>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <CustomFormLabel>{t("system.permissions.name")}</CustomFormLabel>
                <CustomTextField
                  value={data.name}
                  onChange={(e) => handleChange(e, "name")}
                  sx={{ width: "100%" }}
                  error={errors.name.hasError}
                  helperText={errors.name.message}
                  disabled={loading}
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <CustomFormLabel>{t("system.permissions.table.description")}</CustomFormLabel>
                <CustomTextField
                  value={data.description}
                  onChange={(e) => handleChange(e, "description")}
                  sx={{ width: "100%" }}
                  error={errors.description.hasError}
                  helperText={errors.description.message}
                  disabled={loading}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomFormControl label={t('system.permissions.table.isExternal')}
                  control={
                    <CustomCheckbox
                      checked={data.isExternal}
                      onChange={(e) => handleChange(e, "isExternal")}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <CustomFormControl label={t('system.permissions.table.isRestricted')}
                  control={
                    <CustomCheckbox
                      checked={data.isRestricted}
                      onChange={(e) => handleChange(e, "isRestricted")}
                      disabled={data.isExternal}
                    />
                  }
                />
              </Grid>
            </Grid>
          </SectionTopInfo>
          {errors.general.hasError && (
            <SectionBottomInfo>
              <Text>{errors.general.message}</Text>
            </SectionBottomInfo>
          )}
        </ContainerInfo>
      </Body>
      <ModalFooter>
        <SectionRight>
            <CustomButtonV2
              btnType="cancel"
              onClick={() => handleClose()}
              disabled={loading}
            >
              {t('common.cancel')}
            </CustomButtonV2>
            <Spacer />
            <CustomButtonV2
              btnType="primary"
              onClick={() => handleAccept()}
              disabled={loading}
            >
              {t('common.save')}
            </CustomButtonV2>
        </SectionRight>
      </ModalFooter>
    </Container>
  );
};
